import React, { Fragment, ReactElement, useEffect, useState } from 'react';

import ModalDialog from 'src/components/ModalDialog';

interface IRackRemoveProps {
  rackId: number;
  rackIdentifier: string;
  onDelete: () => Promise<void>;
}

export const RemoveRack = ({ rackId, rackIdentifier, onDelete }: IRackRemoveProps) => {

  const dialogId = `delrack-${rackId}`;
  const cancel = (event: React.UIEvent<HTMLAnchorElement>) => {
    const el = document.getElementById(dialogId);
    if (el) {
      el.click();
    }
  }
  const deleteRack = (event: React.UIEvent<HTMLAnchorElement>) => {
    onDelete()
      .then(() => {
        const el = document.getElementById(dialogId);
        if (el) {
          el.click();
        }
      })
  }

  return <ModalDialog
    id={dialogId}
    title={`Delete Rack: ${rackIdentifier}`}
    icon="trash"
    buttonText="Delete"
  >
    <div className="uk-align-right">
      <a className="uk-button" onClick={(e) => cancel(e)}>Cancel</a>
      <a className="uk-button uk-button-danger" onClick={(e) => deleteRack(e)}>Delete</a>
    </div>
  </ModalDialog>

}
